<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <!-- {{ this.ferg() }} -->
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">EDITAR COMUNICACIÓN CON API</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <p class="important_copy">
                      <b>IMPORTANTE</b> <br />
                      Esta acción necesita un reinicio de todas las instancias
                      de la aplicación dentro del servidor, simplemente pare los
                      servicios y vuelvas a iniciarlos.
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="name"
                      v-model="data.name"
                      :rules="nameRules"
                      label="Nombre"
                      required
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="time"
                      type="number"
                      v-model.number="data.time"
                      :rules="[fieldRules.nullField, fieldRules.zeroField]"
                      label="Tiempo en minutos"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click.stop="show = false">Cerrar</v-btn>
                <v-btn
                  :disabled="!valid"
                  depressed
                  large
                  color="primary"
                  @click="validate"
                  >GUARDAR</v-btn
                >
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "TimerEditComp",
  components: {},
  props: ["visible", "data"],
  data() {
    return {
      valid: true,
      serviceRule: [(v) => !!v || "El campo es requerido"],
      nameRules: [(v) => !!v || "El campo es requerido"],
      fieldRules: {
        nullField: (v) => v != null || "El campo es requerido",
        zeroField: (v) => v != 0 || "El campo no puede ser 0",
      },
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.form.reset();
        this.$emit("close");
        // Or any other way you want to close your modal
      }
    });
  },
  methods: {
    ...mapActions(["updateTimerConfig", "alertSnackbar"]),
    validate() {
      if (this.$refs.form.validate()) {
        this.registerForm();
      }
    },
    async registerForm() {
      try {
        let form = {
          _id: this.data._id,
          name: this.data.name,
          time: this.data.time,
        };
        let update = await this.updateTimerConfig(form);
        this.$refs.form.reset();
        this.show = false;
        if (update == 200) {
          this.$root.$emit("reload"); // parametro update tabla
          this.alertSnackbar({
            snackbar: true,
            text: "El tiempo de comunicación se ha actualizado.",
          });
        } else {
          this.alertSnackbar({
            snackbar: true,
            text: "ocurrio un error con el servidor.",
          });
        }
      } catch (error) {
        this.alertSnackbar({
          snackbar: true,
          text: "ocurrio un error inesperado.",
        });
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset();
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
p.important_copy {
  margin-bottom: 0;
  font-size: 0.9rem;
}
</style>
